import { getToken } from "auth/dataProvider.utils";

export const download = (url, fileName, method = "GET", data = null, shouldDownload = true) => {
  const requestData = {
    method: method,
    mode: "cors",
    headers: {
      "X-Session-Id": getToken(),
    },
    responseType: "blob",
  };

  if (data) {
    requestData.headers["Content-Type"] = "application/json";
    requestData.body = JSON.stringify(data);
  }

  return fetch(url, requestData)
    .then(response => {
      if (response.ok && response.status !== 400) {
        return {
          name: fileName || response.headers.get("X-File-Name"),
          blob: response.blob(),
        };
      }
      if (response.status === 400) {
        return response.json();
      }
      throw Error(`Request rejected with status ${response.status}`);
    })
    .then(data => {
      if (data.ErrorCode) return Promise.reject(data);
      if (data.errorCode) return Promise.reject(data);
      return Promise.resolve(data);
    })
    .then(data => {
      return data.blob.then(blob => {
        if (!shouldDownload) {
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
          return { blob, name: data.name };
        }

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.name);
        } else {
          const link = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = link;
          a.download = data.name;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      });
    });
};

// Same as fetchBlobImage, but also exposes the response headers — for endpoints that carry
// metadata next to the image (e.g. X-Expires-In-Seconds on the attendance QR code).
export const fetchBlobImageWithHeaders = url => {
  const requestData = {
    method: "GET",
    mode: "cors",
    headers: {
      "X-Session-Id": getToken(),
    },
  };

  return fetch(url, requestData).then(response => {
    if (response.status === 200) {
      return response.blob().then(blob => ({ blob, headers: response.headers }));
    }
    if (response.status === 204) {
      return { blob: null, headers: response.headers };
    }
    throw new Error(`Грешка при извличане на снимка: ${response.status}`);
  });
};

export const fetchBlobImage = url => fetchBlobImageWithHeaders(url).then(({ blob }) => blob);
